//Content.js
import React, {Component} from 'react';
import { Link } from 'react-router-dom';


export default class Content extends Component {

	constructor(props)
	{
			console.log(props);
		    super(props);
		this.state = {
				content : {
				"contentId":0,
				"contentImageFile":"",
				"contentImageFileType":0,	
				"contentTitle":"",
				"contentName":"",
				"inputSourceValueCode":0,
				"securityContextId":0,
				"createUser":0,
				"createDate": new Date(),
				"lastUpdateUser": 0,
				"lastUpdateDate": new Date(),
				"contentCdata":"",
				"contentBdata":"",
				"deleteFlag":0,
				"contentTypes":"",
				"proofingStatusCode":0,
				"proofingStatusMsg": "",
				"partNumber":"",
				"recordCount":0,
				"filesize":0,
				"uploadFileType":0,
				"platformEntryPoint":null,
				"serviceEntryPoint":null,
				"callbackEntryPoint":null,
				"httpMethod":null,
				"rate":0.0,
				"billingMethod":null,
				"authKey":null,
				"apiKey":null,
				"apiSecret":null,
				"version":null
			}
		}
	}

    render(){

        return (
				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="/vlm-homepage" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<div class="m-portlet__body  m-portlet__body--no-padding">
								<div class="row m-row--no-padding m-row--col-separator-xl">
								
								
									<div class="col-xl-3">
										<div class="m-widget14">
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/mydocuments"><img src="/images/DashboardIcon/Icon/Artifacts.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Documents</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>

											<hr/>										
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/mymusic"><img src="/images/DashboardIcon/Icon/Recall.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Music</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>										
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/myphotos"><img src="/images/DashboardIcon/Icon/ManageUserProjects.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Photos</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>										
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/myvideos"><img src="/images/DashboardIcon/Icon/SequenceSchedule.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Videos</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>										
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/mylinks"><img src="/images/DashboardIcon/Icon/ProjectMilestones.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Bookmarks</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>


										</div>
									</div>
								
									<div class="col-xl-3">
										<div class="m-widget14">
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/desktops"><img src="/images/DashboardIcon/Icon/Desktop.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Desktops</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-brand"></span>
													</div>
												</div>
											</div>
											<hr/>
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/projects"><img src="/images/DashboardIcon/Icon/Projects.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Projects</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-danger"></span>
													</div>
												</div>
											</div>
											<hr/>
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/tasks"><img src="/images/DashboardIcon/Icon/Inventory.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Tasks</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>

											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/articles"><img src="/images/DashboardIcon/Icon/Content.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Articles</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr />
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/knowledge-base"><img src="/images/DashboardIcon/Icon/ManageContentTypes.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Knowledge</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>

										</div>
									</div>

									<div class="col-xl-3">
										<div class="m-widget14">
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/circles"><img src="/images/DashboardIcon/Icon/CRM.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Circles</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>										
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/journals"><img src="/images/DashboardIcon/Icon/JournalEntry.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Journals</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>										
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/contacts"><img src="/images/DashboardIcon/Icon/JobApplicants.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Contacts</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/calendar"><img src="/images/DashboardIcon/Icon/PlanningSchedule.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Calendar</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/workflows"><img src="/images/DashboardIcon/Icon/WorkflowQueue.png" /></Link>
														</h3>
														<span class="m-widget1__desc h1">Workstreams</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
										</div>
									</div>


									<div class="col-xl-3">
										<div class="m-widget14">
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/vlm-home">
															<i class="fas fa-home fa-5x" style={{"color" : "green"}}></i>
															</Link>
														</h3>
														<br />
														<span class="m-widget1__desc h1">Home</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/vlm-vehicles">
															<i class="fas fa-car fa-5x" style={{"color" : "red"}}></i>
															</Link>
														</h3>
														<span class="m-widget1__desc h1">Vehicles</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/vlm-iot">
																<i class="fas fa-wifi fa-5x" style={{"color" : "black"}}></i>
															</Link>
														</h3>
														<br />
														<span class="m-widget1__desc h1">Things</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/vlm-cameras">
															<i class="fas fa-video fa-5x" style={{"color" : "grey"}}></i>
															</Link>
														</h3>
														<br />
														<span class="m-widget1__desc h1">Cameras</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>
											<hr/>
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">
															<Link to="/vlm-user-database">
															<i class="fas fa-database fa-5x" style={{"color" : "brown"}}></i>
															</Link>
														</h3>
														<span class="m-widget1__desc h1">Databases</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success"></span>
													</div>
												</div>
											</div>

										</div>
									</div>
								</div>
							</div>
						</div>            
					</div>		

	            </div>	
            </div>
            
			</div>
			</div>
			)
		}
	}